module.exports = __webpack_public_path__ + "static/media/c7b1b6a8.jpg";